import { render, staticRenderFns } from "./NavigatorQuizs.vue?vue&type=template&id=5db29733"
import script from "./NavigatorQuizs.vue?vue&type=script&lang=js"
export * from "./NavigatorQuizs.vue?vue&type=script&lang=js"
import style0 from "./NavigatorQuizs.vue?vue&type=style&index=0&id=5db29733&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports